import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TPublicAttachmentApi } from './types';

export const publicAttachment: TPublicAttachmentApi = {
	getPublicAttachmentUploadInfo: (hash) =>
		http.get(endpoint.publicAttachment.GET_UPLOAD_INFO(hash)).then((response) => response.data),
	uploadPublicAttachment: (payload) =>
		http
			.post(endpoint.publicAttachment.UPLOAD_FILE(payload.hash), payload.file)
			.then((response) => response.data),
};
